<header class="container header-bg">
  <div class="header-first-content">
    <div class="header-logo-container">
      <a class="flex-logo" routerLink="/auth">
        <img src="assets/icons/b3-logo.svg" alt="Logotipo da Bolsa de Valores" />
      </a>
    </div>
    <div class="header-actions">
      <div class="header-notification-icon">
        <a routerLink="auth/notifications">
          <img src="../assets/icons/sino.svg" alt="" width="15px" height="19px" />
          <span class="header-notification-count">{{ itemCount }}</span>
        </a>
      </div>
      <div class="header-dropdown" (click)="toggleDropdown()" *ngIf="hasToken" tabindex="0">
        <div class="header-dropdown-name">
          <span class="header-dropdown-user">{{ getShortName() }}</span>
          <img [ngClass]="isArrowDown ? 'arrow-down' : 'arrow-up'" src="assets/icons/arrow-down.svg" alt="" />
        </div>
        <div class="header-dropdown-content" *ngIf="isOpen">
          <div>
            <a routerLink="/manage-profile">
              <div class="header-dropdown-flex-profile" *ngIf="hasPrivilege">
                <span>Gerenciar<br>Acessos/Permissões</span>
              </div>
            </a>
            <div class="header-dropdown-flex" (click)="onLogout()">
              <a href="">Logout</a>
              <img src="assets/icons/logout.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>